function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    query getProductReleases($where: Products_bool_exp) {\n      Products(where: $where, limit: 1) {\n        name\n        owner\n        type\n        ProductVersion {\n          id\n        } \n        Releases: ProductVersions(\n          where: {",
        "}\n          order_by: [{ updated_at: desc }]\n        ) {\n          status\n          version\n          release_notes\n          updated_at \n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      query getProductProgrammingLanguages {\n        ProductProgrammingLanguage {\n          value\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n    query getProduct(\n      $where: Products_bool_exp\n      $withDesc: Boolean!\n      $withDocs: Boolean!\n    ) {\n      Products(where: $where, limit: 1) {\n        name\n        id\n        owner\n        owner_name\n        programming_language\n        created_at\n        updated_at\n        type\n        # Get only the latest Product version to install\n        ProductVersion {\n          ...activeVersionFields\n          ",
        "\n        }\n        LatestVersion: ProductVersions(\n          order_by: [{ updated_at: desc }]\n          limit: 1\n        ) {\n          ...activeVersionFields\n          ",
        "\n        }\n        Releases: ProductVersions_aggregate(where: {",
        "}) {\n          aggregate {\n            count\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    query getProductInstances(\n      $where: Instances_bool_exp\n      $orderBy: [Instances_order_by!]\n      $offset: Int\n      $limit: Int\n    ) {\n      Instances(\n        offset: $offset\n        limit: $limit\n        order_by: $orderBy\n        where: $where\n      ) {\n        id\n        name\n        created_at\n        Project {\n          name\n          api_account_id\n        }\n        ActiveDeployment {\n          Package {\n            ProductVersions {\n              version\n            }\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import { gql } from "graphql-request";
import { ProductType_Enum } from "../types";
import { getAccountId } from "../utils";
import { activeVersionFragment } from "./fragments";
import { useQuery } from "./useGraphQLApi";
import { useValidSession } from "./useValidSession";
export var releaseQuery = function(accountId) {
    var filterIsLive = "status: { _eq: live }";
    return accountId ? '_or: [\n          { Product: { owner: { _eq: "'.concat(accountId, '" } } },\n          { ').concat(filterIsLive, " }\n        ]") : filterIsLive;
};
export var useGetReleasesQuery = function(params) {
    var GET_RELEASES_QUERY = gql(_templateObject(), releaseQuery(useValidSession() ? getAccountId() : null));
    var _useQuery = useQuery(GET_RELEASES_QUERY, _object_spread({}, params)), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    return {
        data: data === null || data === void 0 ? void 0 : data.Products.map(function(_param) {
            var ProductVersion = _param.ProductVersion, rest = _object_without_properties(_param, [
                "ProductVersion"
            ]);
            return _object_spread_props(_object_spread({}, rest), {
                isLive: Boolean(ProductVersion),
                isPublic: rest.type === ProductType_Enum.Public
            });
        })[0],
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};
export var useGetProductProgrammingLanguagesQuery = function() {
    var GET_PROGRAMMING_LANGUAGES_QUERY = gql(_templateObject1());
    var _useQuery = useQuery(GET_PROGRAMMING_LANGUAGES_QUERY), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    var _data_ProductProgrammingLanguage;
    return {
        data: (_data_ProductProgrammingLanguage = data === null || data === void 0 ? void 0 : data.ProductProgrammingLanguage) !== null && _data_ProductProgrammingLanguage !== void 0 ? _data_ProductProgrammingLanguage : [],
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};
export var useGetProductQuery = function(params) {
    var GET_PRODUCT_QUERY = gql(_templateObject2(), activeVersionFragment, useValidSession() ? "setup_configuration" : "", useValidSession() ? "setup_configuration" : "", releaseQuery(getAccountId()));
    var _useQuery = useQuery(GET_PRODUCT_QUERY, _object_spread_props(_object_spread({}, params), {
        includeFields: {
            withDesc: true,
            withDocs: false
        }
    })), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    return {
        data: data === null || data === void 0 ? void 0 : data.Products.map(function(_param) {
            var _param_LatestVersion = _param.LatestVersion, LatestVersion = _param_LatestVersion === void 0 ? [] : _param_LatestVersion, ProductVersion = _param.ProductVersion, rest = _object_without_properties(_param, [
                "LatestVersion",
                "ProductVersion"
            ]);
            return _object_spread_props(_object_spread({}, rest), {
                LatestVersion: LatestVersion,
                ProductVersion: ProductVersion !== null && ProductVersion !== void 0 ? ProductVersion : LatestVersion[0],
                isLive: Boolean(ProductVersion),
                isPublic: rest.type === ProductType_Enum.Public
            });
        })[0],
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};
export var useGetProductInstancesQuery = function(params) {
    var GET_PRODUCT_INSTANCES_QUERY = gql(_templateObject3());
    var _useQuery = useQuery(GET_PRODUCT_INSTANCES_QUERY, params), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating;
    var _data_Instances;
    return {
        data: (_data_Instances = data === null || data === void 0 ? void 0 : data.Instances) !== null && _data_Instances !== void 0 ? _data_Instances : [],
        error: error === null || error === void 0 ? void 0 : error.message,
        loading: isValidating
    };
};

//# sourceMappingURL=useProducts.js.map